import React from "react";

import { useExamLockerContext } from "components/ExamLockerContext/ExamLockerContext";
import FormBlock from "components/FormBlock";
import { useVetExamContext } from "../VetExamProvider/VetExamProvider";
import ExamDetails from "./ExamDetails";
import { checkSelectingFieldsOneEntry } from "../helper";
import AddEntryButton from "../AddEntryButton";
import {
  createEmptyExamDetail,
  EVetExamFields,
  IExamDetail,
  MAX_ENTRIES_AMOUNT
} from "../options";
import useStyles from "./styles";

const ADD_DETAILS_ENTRY = "Add Another Exam Details Entry";

const ExamDetailsList = () => {
  const classes = useStyles();
  const { lockExam } = useExamLockerContext();
  const {
    values: { examDetails },
    setFieldValue
  } = useVetExamContext();

  const handleAddClick = () => {
    setFieldValue(EVetExamFields.EXAM_DETAILS, [
      ...examDetails,
      createEmptyExamDetail()
    ]);
    lockExam();
  };

  const renderAddEntry = () => {
    const isDisabled = !examDetails.every(checkSelectingFieldsOneEntry);

    return (
      <>
        {examDetails.length < MAX_ENTRIES_AMOUNT && (
          <AddEntryButton
            title={ADD_DETAILS_ENTRY}
            onClick={handleAddClick}
            disabled={isDisabled}
          />
        )}
      </>
    );
  };

  const renderEntries = () =>
    examDetails.map((item: IExamDetail, index: number) => (
      <ExamDetails key={item.id} examDetailsItem={item} index={index + 1} />
    ));

  return (
    <FormBlock
      title="Exam Details"
      name={EVetExamFields.EXAM_DETAILS}
      actionsComponent={renderAddEntry()}
      isRequired={true}
      className={classes.root}
    >
      {renderEntries()}
    </FormBlock>
  );
};

export default ExamDetailsList;
